import React from "react";
import { useInactivityLogout } from "../hooks/useInactivityLogout";
import InactivityWarning from "./InactivityWarning";

/**
 * Mounts inactivity-logout machinery + warning modal for an authenticated shell.
 * Drop this anywhere inside `AppShell` / `ModuleAppShell` / `MasterFinanceShell`
 * — it has no visible UI on its own; the modal opens only when the user has been idle.
 */
export default function AuthedShellChrome() {
    const { warning, remainingSec, stayLoggedIn } = useInactivityLogout({
        idleMs: 30 * 60 * 1000,
        warningMs: 3 * 60 * 1000,
    });
    return (
        <InactivityWarning open={warning} remainingSec={remainingSec} onStay={stayLoggedIn} />
    );
}
